<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">Cover Design: <a href="http://www.written-ink.com" target="_blank"><span class="t5">Written Ink Designs</span></a> | written-ink.com</p>
<p class="p1">Image(s) used under a Standard Royalty-Free License.</p>
<p class="p1">All rights reserved.</p>
<p class="p2"> </p>
<p class="p2">WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.</p>
<p class="p2">No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.</p>
<p class="p2">This book is for ADULT AUDIENCES ONLY. It may contain sexually explicit scenes and graphic language which might be considered offensive by some readers. Please store your files where they cannot be accessed by minors.</p>
<p class="p2">This is a work of fiction. Names, characters, places, and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.</p>
<p class="p2">Published in the United States of America.</p>
<p class="p3">* * * *</p>
<p class="p2">This book is dedicated to all those cats out there who do everything in their power to help their humans find love!</p>
<p class="p3">* * * *</p>
<p class="p0"><span class="t2"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?c2a2fec2